import { Carousel } from "@fancyapps/ui/dist/carousel/";
import { Arrows } from "@fancyapps/ui/dist/carousel/carousel.arrows.js";
import { Dots } from "@fancyapps/ui/dist/carousel/carousel.dots.js";
import "@fancyapps/ui/dist/carousel/carousel.css";
import "@fancyapps/ui/dist/carousel/carousel.dots.css";
import "@fancyapps/ui/dist/carousel/carousel.arrows.css";
import "@fancyapps/fancybox";

export const createGallery = () => {
	// Create gallery function
	let galleryid = 0;

	document.querySelectorAll(".gallery").forEach((gallery) => {
		const images = gallery.querySelectorAll("img");
		images.forEach((img) => {
			img.classList.add("gallery-image");
			const link = document.createElement("a");
			link.className = "gallery-image-link";
			img.parentNode.insertBefore(link, img);
			link.appendChild(img);

			link.setAttribute("data-fancybox", "group");
			link.setAttribute("data-caption", img.getAttribute("longdesc") || ""); // || img.getAttribute("alt"));
			link.setAttribute("rel", `gallery_${galleryid}`);
			link.setAttribute("href", img.getAttribute("data-src"));
			// link.setAttribute("title", img.getAttribute("title")); // || img.getAttribute("alt"));
		});

		galleryid++;
	});
};

export const createCarousel = () => {
	let carouselid = 0;

	document.querySelectorAll(".gallery > .gallery-content").forEach((content) => {
		const images = content.querySelectorAll("img");
		// images is not directly inside the gallery-content div, clean and re-append
		const onlyImages = [...content.children].every(el => el.tagName === "IMG");
		if (!onlyImages) {
			content.innerHTML = "";
			images.forEach(img => content.appendChild(img));
		}

		images.forEach((img) => {
			img.classList.add("gallery-image");
			const slide = document.createElement("div");
			slide.className = "f-carousel__slide";
			img.parentNode.insertBefore(slide, img);
			slide.appendChild(img);

			slide.setAttribute("data-fancybox", "group");
			slide.setAttribute("data-caption", img.getAttribute("longdesc") || "");
			// slide.setAttribute("data-caption", ""); // Do not use caption in carousel
			slide.setAttribute("rel", `gallery_${carouselid}`);
			slide.setAttribute("href", img.getAttribute("data-src"));
			// slide.setAttribute("title", img.getAttribute("title")); // || img.getAttribute("alt"));
		});

		content.id = `gallery_${carouselid}`;
		content.classList.remove("gallery-content");
		content.classList.add("carousel-content");
		carouselid++;

		const container = document.getElementById(content.id);
		const options = {
			Dots: {
				minCount: 2,
			},
			slidesPerPage: 1,
		};

		// Initialize the carousel
		// eslint-disable-next-line no-unused-vars
		Carousel(container, options, { Arrows, Dots }).init();
	});
};
